import React__default, { createContext, useReducer, useState, useEffect, useContext } from 'react';
import { proposalReducer, initialState } from './proposalReducer.esm.js';
import { baseUrl, getMuid } from '../../lib/utils.esm.js';

const ProposalContext = /*#__PURE__*/createContext(undefined);
ProposalContext.displayName = 'ProposalContext';
const ProposalProvider = ({
  children
}) => {
  const [state, dispatch] = useReducer(proposalReducer, initialState);
  const [isOpen, setIsOpen] = useState(false);
  const [offerData, setOfferData] = useState(null);
  const [source, setSource] = useState('list');
  const openProposal = (offerData, source) => {
    setOfferData(offerData);
    setSource(source);
    setIsOpen(true);
  };
  const closeProposal = () => {
    setIsOpen(false);
  };
  const fetchProposals = async () => {
    try {
      const response = await fetch(`${baseUrl}${window.apiV6Config.path}/b2b/proposals?muid=${getMuid()}&locale=${window.dataGlobalSettings?.locale || 'en'}`);
      if (!response.ok) {
        throw new Error(`Failed to fetch proposals: ${response.status} ${response.statusText}`);
      }
      const data = await response.json();
      dispatch({
        type: "SET_PROPOSALS",
        payload: data.filter(proposal => proposal?.status === 'enabled')
      });
    } catch (error) {
      console.error('Error fetching proposals:', error);
      dispatch({
        type: "SET_PROPOSALS",
        payload: []
      });
    }
  };
  const fetchClients = async () => {
    try {
      const response = await fetch(`${baseUrl}${window.apiV6Config.path}/b2b/clients?muid=${getMuid()}&locale=${window.dataGlobalSettings?.locale || 'en'}`);
      if (!response.ok) {
        throw new Error(`Failed to fetch clients: ${response.status} ${response.statusText}`);
      }
      const data = await response.json();
      dispatch({
        type: "SET_CLIENTS",
        payload: data
      });
    } catch (error) {
      console.error('Error fetching clients:', error);
      dispatch({
        type: "SET_CLIENTS",
        payload: []
      });
    }
  };
  useEffect(() => {
    if (window.dataGlobalSettings?.siteType === 3) {
      fetchProposals();
      fetchClients();
      document.addEventListener('travelyo:user', e => {
        const customEvent = e;
        if (customEvent.detail.name === 'loginModal.success') {
          fetchProposals();
          fetchClients();
        }
      });
    }
  }, []);
  return /*#__PURE__*/React__default.createElement(ProposalContext.Provider, {
    value: {
      state,
      dispatch,
      fetchProposals,
      fetchClients,
      offerData,
      source,
      isOpen,
      openProposal,
      closeProposal
    }
  }, children);
};
ProposalProvider.displayName = 'ProposalProvider';
const useProposalContext = () => {
  const context = useContext(ProposalContext);
  if (!context) {
    throw new Error("useProposalContext must be used within a ProposalProvider");
  }
  return context;
};

export { ProposalContext, ProposalProvider, ProposalProvider as default, useProposalContext };
//# sourceMappingURL=proposalContext.esm.js.map
